export class ArticleSearchQueryParams {
    product?: string = 'MEDIA';
    module?: string = 'ALL';
    words?: string;
}